import {
  FileWarningIcon,
  Loader2,
  MailWarning,
  MessageCircleWarningIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import React from "react";
import { Button } from "@/components/ui/button";

interface StoryboardLongLoadingProps {
  onOpenInNewTab: () => void;
  onInteractToDebug: () => void;
  onRefresh: () => void;
  containerWidth?: number;
  containerHeight?: number;
}

const StoryboardLongLoading = ({
  onOpenInNewTab,
  onInteractToDebug,
  onRefresh,
  containerWidth,
  containerHeight,
}: StoryboardLongLoadingProps) => {
  const isCompactMode =
    containerWidth &&
    containerHeight &&
    (containerWidth < 250 || containerHeight < 250);

  return (
    <div className="w-full h-full bg-black/60 backdrop-blur-xs flex items-center justify-center overflow-hidden p-2">
      {isCompactMode ? (
        <div className="flex flex-row gap-2">
          <div
            className="bg-secondary-0 rounded-md p-1.5 cursor-pointer hover:bg-secondary-400 transition-colors pointer-events-auto shadow-lg"
            onClick={onRefresh}
            data-tooltip-id="tooltip"
            data-tooltip-html={`
            <div class="max-w-xs">
              <div class="font-semibold mb-1 text-white">Storyboard Unresponsive</div>
              <div class="text-xs opacity-80">Please check your terminal or AI chat for errors. If issues persist, contact support for help.</div>
              <div class="mt-2 text-xs font-medium text-blue-300">Click to refresh</div>
            </div>
          `}
            data-tooltip-place="top"
          >
            <Loader2 className="w-4 h-4 animate-spin stroke-white" />
          </div>
        </div>
      ) : (
        <div
          className="w-full flex flex-col max-w-lg"
          style={{
            maxHeight: "90%",
          }}
        >
          <Card className="shadow-lg border-gray-200 bg-white">
            <CardContent className="p-8 text-center bg-white flex flex-col items-center justify-center">
              <TriangleAlertIcon className="w-10 h-10 mb-4 text-red-500" />
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Storyboard Unresponsive
              </h3>
              <p className="text-base text-gray-700 leading-relaxed">
                Please check your terminal or AI chat for potential errors.{" "}
                <br /> If issues persist, contact support for help.
              </p>
              <div className="flex flex-row gap-2 justify-center">
                <Button
                  variant="secondary"
                  className="mt-4"
                  onClick={onRefresh}
                >
                  Refresh
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
};

export default StoryboardLongLoading;
